/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_MuteInputs */

const th_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดเสียง`)
};

const en_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mute`)
};

const ja_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュート`)
};

const zh_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`静音`)
};

const es_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silenciar`)
};

const pt_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem som`)
};

const id_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisukan`)
};

const fr_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper le son`)
};

const tl_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-mute`)
};

const vi_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt tiếng`)
};

const ko_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`음소거`)
};

const de_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stumm`)
};

const ru_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без звука`)
};

const tr_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi kapat`)
};

const it_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muto`)
};

const pl_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycisz`)
};

const uk_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без звуку`)
};

const hi_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मौन`)
};

const ar_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتم`)
};

const ms_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senyap`)
};

const bn_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিঃশব্দ`)
};

const zh_tw2_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`靜音`)
};

const zh_hk2_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`靜音`)
};

const ur_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خاموش`)
};

const fa_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بی‌صدا`)
};

const sw_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zima sauti`)
};

const nl_video_mute = /** @type {(inputs: Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geluid uit`)
};

/**
* | output |
* | --- |
* | "Mute" |
*
* @param {Video_MuteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_mute = /** @type {((inputs?: Video_MuteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_MuteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_mute(inputs)
	if (locale === "ja") return ja_video_mute(inputs)
	if (locale === "zh") return zh_video_mute(inputs)
	if (locale === "es") return es_video_mute(inputs)
	if (locale === "pt") return pt_video_mute(inputs)
	if (locale === "id") return id_video_mute(inputs)
	if (locale === "fr") return fr_video_mute(inputs)
	if (locale === "tl") return tl_video_mute(inputs)
	if (locale === "vi") return vi_video_mute(inputs)
	if (locale === "ko") return ko_video_mute(inputs)
	if (locale === "de") return de_video_mute(inputs)
	if (locale === "ru") return ru_video_mute(inputs)
	if (locale === "tr") return tr_video_mute(inputs)
	if (locale === "it") return it_video_mute(inputs)
	if (locale === "pl") return pl_video_mute(inputs)
	if (locale === "uk") return uk_video_mute(inputs)
	if (locale === "hi") return hi_video_mute(inputs)
	if (locale === "ar") return ar_video_mute(inputs)
	if (locale === "ms") return ms_video_mute(inputs)
	if (locale === "bn") return bn_video_mute(inputs)
	if (locale === "zh-TW") return zh_tw2_video_mute(inputs)
	if (locale === "zh-HK") return zh_hk2_video_mute(inputs)
	if (locale === "ur") return ur_video_mute(inputs)
	if (locale === "fa") return fa_video_mute(inputs)
	if (locale === "sw") return sw_video_mute(inputs)
	if (locale === "nl") return nl_video_mute(inputs)
	return en_video_mute(inputs)
});